import { IProject } from 'models/general';
import { IProfileFieldConstraintsMap } from 'types';
import { ConsentAgreementKind, ConsentAgreementType } from 'constants/common';

export interface ConsentAgreement {
  consentAgreementContentId: string;
  consentAgreementId: string;
  type: ConsentAgreementType;
  kind: ConsentAgreementKind;
  htmlContent: string;
  projectId: string | null;
  languageCode: string;
  languageId: string;
  /**
   * @deprecated Do NOT read for per-worker decisions. `cache.consentAgreements` is a single global
   * array that `fetchConsentAgreements.fulfilled` replaces wholesale, and the fetch carries a
   * `workerId` — so these flags are only ever valid for the most recently fetched worker and are
   * stale or wrong when switching workers or working offline.
   * Use `onboarding.acceptedStandardConsentIds` / `acceptedCustomConsentIds` instead (populated
   * from these flags per-worker, split by kind).
   */
  isAccepted: boolean;
  /** @deprecated See `isAccepted`. Currently read nowhere. */
  isAcceptedOn: string | null;
  sequenceNumber: number;
  name: string;
}

interface ICacheState {
  projects: any[];
  whitelistedProjectIds: string[];
  project: IProject;
  projectSettings: any;
  projectProfileCustomFields: any;
  workerProfileFieldsForAllCompanies: any;
  appLanguages: { en: any[]; es: any[] };
  companies: { en: any[]; es: any[] };
  ethnicities: { en: any[]; es: any[] };
  languages: { en: any[]; es: any[] };
  countries: { en: any[]; es: any[] };
  states: { en: any[]; es: any[] };
  iDTypes: { en: any[]; es: any[] };
  projectRoles: { en: any[]; es: any[] };
  skilledTrades: { en: any[]; es: any[] };
  certificationTypes: { en: any[]; es: any[] };
  consentFormFields: { en: any[]; es: any[] };
  consentAgreements: ConsentAgreement[];
  jobTitles: { en: any[]; es: any[] };
  tradeStatus: { en: any[]; es: any[] };
  socJobTitles: { en: any[]; es: any[] };
  languageTurnerProtocol: { en: any[]; es: any[] };
  certificationGroups: { en: any[]; es: any[] };
  hasData: false;
  profileFieldConstraintsMap: IProfileFieldConstraintsMap;
  canCreateUnverifiedWorkers: boolean;
  lastUpdatedAt: string | null;
}

const initialState: ICacheState = {
  projects: [],
  whitelistedProjectIds: [],
  project: {} as IProject,
  projectSettings: {},
  projectProfileCustomFields: {},
  workerProfileFieldsForAllCompanies: [],
  profileFieldConstraintsMap: {},
  canCreateUnverifiedWorkers: false,
  appLanguages: { en: [], es: [] },
  companies: { en: [], es: [] },
  ethnicities: { en: [], es: [] },
  languages: { en: [], es: [] },
  countries: { en: [], es: [] },
  states: { en: [], es: [] },
  iDTypes: { en: [], es: [] },
  projectRoles: { en: [], es: [] },
  skilledTrades: { en: [], es: [] },
  certificationTypes: { en: [], es: [] },
  consentFormFields: { en: [], es: [] },
  consentAgreements: [],
  jobTitles: { en: [], es: [] },
  tradeStatus: { en: [], es: [] },
  socJobTitles: { en: [], es: [] },
  languageTurnerProtocol: { en: [], es: [] },
  certificationGroups: { en: [], es: [] },
  hasData: false,
  lastUpdatedAt: null,
};

export default initialState;
